import Box from '@mui/material/Box';
import { ThemeProvider } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import cn from 'classnames';
import { useState } from 'react';
import { Controller } from 'react-hook-form';
import Switch from 'react-switch';

import { Order } from '../../store/order';
import { theme } from '../../utils/themeProvider';
import styles, { boxShadow, brandColor, brandColorMuted } from '../OrderDeliveryForm/OrderPreferences.module.scss';

function OrderInvoiceForm({ control }) {
  const REQUIRED_FIELD = 'Υποχρεωτικό πεδίο';

  const errorMessages = {
    companyPhone: {
      required: REQUIRED_FIELD,
      pattern: 'Με έγκυρη τιμή',
    },
    AFM: {
      required: REQUIRED_FIELD,
      errorAFMPattern: 'Με έγκυρη τιμή',
    },
  };

  const [invoiceUse, setInvoiceUse] = useState(false);

  function onChangeInvoiceUse() {
    if (!invoiceUse) {
      Order.deleteProperty(['invoice']);
    }
    setInvoiceUse(!invoiceUse);
  }

  return (
    <div className={styles.checkBoxContainer}>
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label htmlFor="" className={styles.checkBoxLabel}>
        <span className={styles.labelText}>Έκδοση τιμολογίου</span>
        <Switch
          checked={invoiceUse}
          onChange={onChangeInvoiceUse}
          onColor={brandColorMuted}
          onHandleColor={brandColor}
          checkedIcon={false}
          uncheckedIcon={false}
          boxShadow={boxShadow}
          activeBoxShadow={boxShadow}
          height={14}
          width={32}
          handleDiameter={20}
          className="react-switch"
        />
      </label>
      <ThemeProvider theme={theme}>
        <div
          className={cn({
            [styles.hideOnUnselected]: !invoiceUse,
            [styles.appearOnSelected]: invoiceUse,
          })}
        >
          <div className={styles.invoiceInputContainer}>
            <Box sx={{ height: '5.5rem', flex: '0.45 1 0' }} className={styles.box}>
              <Controller
                control={control}
                name="companyName"
                defaultValue=""
                rules={{
                  required: invoiceUse,
                }}
                render={({ field: { ref, onChange, ...field }, fieldState: { error } }) => (
                  <TextField
                    {...field}
                    label="Επωνυμία"
                    fullWidth
                    variant="outlined"
                    onChange={onChange}
                    error={error !== undefined}
                    helperText={error && REQUIRED_FIELD}
                  />
                )}
              />
            </Box>
            <Box sx={{ height: '5.5rem', flex: '0.45 1 0' }} className={styles.box}>
              <Controller
                control={control}
                name="profession"
                defaultValue=""
                rules={{
                  required: invoiceUse,
                }}
                render={({ field: { ref, onChange, ...field }, fieldState: { error } }) => (
                  <TextField
                    {...field}
                    label="Επάγγελμα"
                    fullWidth
                    variant="outlined"
                    onChange={onChange}
                    error={error !== undefined}
                    helperText={error && REQUIRED_FIELD}
                  />
                )}
              />
            </Box>
          </div>
          <div className={styles.invoiceInputContainer}>
            <Box sx={{ height: '5.5rem', flex: '0.45 1 0' }} className={styles.box}>
              <Controller
                control={control}
                name="AFM"
                defaultValue=""
                rules={{
                  required: invoiceUse,
                  pattern: /\d{9}/,
                }}
                render={({ field: { ref, onChange, ...field }, fieldState: { error } }) => (
                  <TextField
                    {...field}
                    label="ΑΦΜ"
                    fullWidth
                    variant="outlined"
                    onChange={onChange}
                    error={error !== undefined}
                    helperText={error && errorMessages.AFM[error.type]}
                  />
                )}
              />
            </Box>
            <Box sx={{ height: '5.5rem', flex: '0.45 1 0' }} className={styles.box}>
              <Controller
                control={control}
                name="DOY"
                defaultValue=""
                rules={{
                  required: invoiceUse,
                }}
                render={({ field: { ref, onChange, ...field }, fieldState: { error } }) => (
                  <TextField
                    {...field}
                    label="ΔΟΥ"
                    fullWidth
                    variant="outlined"
                    onChange={onChange}
                    error={error !== undefined}
                    helperText={error && REQUIRED_FIELD}
                  />
                )}
              />
            </Box>
          </div>
          <div className={styles.invoiceInputContainer}>
            <Box sx={{ height: '5.5rem', flex: '0.45 1 0' }} className={styles.box}>
              <Controller
                control={control}
                name="companyAddress"
                defaultValue=""
                rules={{
                  required: invoiceUse,
                }}
                render={({ field: { ref, onChange, ...field }, fieldState: { error } }) => (
                  <TextField
                    {...field}
                    label="Διεύθυνση"
                    fullWidth
                    variant="outlined"
                    onChange={onChange}
                    error={error !== undefined}
                    helperText={error && REQUIRED_FIELD}
                  />
                )}
              />
            </Box>
            <Box sx={{ height: '5.5rem', flex: '0.45 1 0' }} className={styles.box}>
              <Controller
                control={control}
                name="companyPhone"
                defaultValue=""
                rules={{
                  required: invoiceUse,
                  pattern: /^\d{10}$/i,
                }}
                render={({ field: { ref, onChange, ...field }, fieldState: { error } }) => (
                  <TextField
                    {...field}
                    label="Τηλέφωνο εταιρείας"
                    variant="outlined"
                    fullWidth
                    onChange={onChange}
                    error={error !== undefined}
                    helperText={error && errorMessages.companyPhone[error.type]}
                    inputProps={{
                      inputMode: 'numeric',
                      pattern: '[0-9]*',
                    }}
                  />
                )}
              />
            </Box>
          </div>
        </div>
      </ThemeProvider>
    </div>
  );
}

export default OrderInvoiceForm;
